import { Link } from 'react-router-dom';
import { Box, Button, Text, Title } from '@mantine/core';
import { IconAlertCircle, IconPackage } from '@tabler/icons-react';

interface EmptyStateProps {
    isFiltering: boolean;
    onClearFilters: () => void;
}

const EmptyState = ({ isFiltering, onClearFilters }: EmptyStateProps) => {
    return (
        <Box p="xl" py="40px" ta="center">
            <IconAlertCircle size={48} stroke={1.5} color="gray" style={{ opacity: 0.5, marginBottom: 20 }} />
            <Title order={3} mb="sm">No shipments found</Title>
            <Text c="dimmed" mb="lg" maw={500} mx="auto">
                {isFiltering ?
                    "No shipments match your current filters. Try adjusting your search criteria or clearing the filters." :
                    "You don't have any shipments yet. Start by creating a new package to ship."
                }
            </Text>
            {isFiltering ? (
                <Button
                    variant="outline"
                    onClick={onClearFilters}
                >
                    Clear Filters
                </Button>
            ) : (
                <Button
                    component={Link}
                    to="/packages"
                    leftSection={<IconPackage size={16} />}
                >
                    Ship a Package
                </Button>
            )}
        </Box>
    );
};

export default EmptyState;
